import {
  Entitlement,
  EntitlementKind,
  EntitlementStatus,
  EntitlementSubscription,
} from "../Entitlement";
import { Offer } from "../Offer";
import { Plan } from "../Plan";
import { Status } from "../Subscription";
import { MockOffer } from "./MockOffer";

export class MockEntitlement implements Entitlement {
  private static INDEX = 0;
  uuid: string;
  public kind = EntitlementKind.PASS;
  public name = "foo";
  public offer: Offer = new MockOffer();
  public plan?: Plan;
  public status = EntitlementStatus.UNACTIVE;
  public items = ["pass:bar"];
  public subscription?: EntitlementSubscription | undefined;

  constructor() {
    MockEntitlement.INDEX++;
    this.uuid = `uuid-${MockEntitlement.INDEX}`;
  }
}

export class MockEntitlementSubscription implements EntitlementSubscription {
  private static INDEX = 0;
  public status = Status.ACTIVE;
  public uuid: string;
  public cancelDate?: string | undefined;
  public organizationName = "orga";
  public partnerId = "partnerId";
  public purchaseDate = "2024-05-18T00:00:00Z";
  public currentPeriodEnd = "2024-05-18T00:00:00Z";
  public cancelDateUpdatedAt?: string | undefined;
  constructor() {
    MockEntitlementSubscription.INDEX++;
    this.uuid = `uuid-${MockEntitlementSubscription.INDEX}`;
  }
}
